export interface Bonus {
  number: string
  value: string
  title: string
  description: string
  image: string
}
export const bonuses: Bonus[] = [
  {
    number: '01',
    value: '$50',
    title: 'Biblia compingu jazzowego',
    description:
      'Każdy wzorzec compingu, którego potrzebują Twoi uczniowie, uporządkowany według feelingu i trudności — voicingi, rytmy i ćwiczenia gotowe do rozdania.',
    image: 'https://cdn.magicpatterns.com/uploads/nn9BW7Eqg5Ao83xSGVnjEF/jazz_1.webp',
  },
  {
    number: '02',
    value: '$50',
    title: 'Mistrzostwo ii-V-I we wszystkich tonacjach',
    description:
      'Pełny cykl rozpisany we wszystkich dwunastu tonacjach, z prowadzeniem głosów, substytucjami i ścieżkami ćwiczeń dla każdego poziomu.',
    image: 'https://cdn.magicpatterns.com/uploads/p17FZVosj3vtbRqrcV2qcm/jazz_2.webp',
  },
  {
    number: '03',
    value: '$50',
    title: 'Ekspresowa biblioteka standardów jazzowych',
    description:
      'Rozpisane standardy z melodią, harmonią i wskazówkami do improwizacji — nowy utwór nauczysz bez żadnych przygotowań.',
    image: 'https://cdn.magicpatterns.com/uploads/pTRKo3EMerGeaTPbobxcKk/jazz_3.webp',
  },
  {
    number: '04',
    value: '$50',
    title: 'Przewodnik przetrwania na jam session',
    description:
      'Savoir-vivre, odliczanie, wymiana chorusów i sposoby wyjścia z pomyłek — wszystko, czego uczniowie potrzebują przed pierwszym jamem.',
    image: 'https://cdn.magicpatterns.com/uploads/jponu5iWTzNDZ47dwjbcYT/jazz_4.webp',
  },
  {
    number: '05',
    value: '$50',
    title: 'Masterclass transkrypcji',
    description:
      'Metoda krok po kroku, jak uczyć uczniów zdejmowania fraz ze słuchu — od czterotaktowych motywów po całe solówki.',
    image: 'https://cdn.magicpatterns.com/uploads/vQVrnXBPQpeHH4HWKPX92W/jazz_5.webp',
  },
  {
    number: '06',
    value: '$50',
    title: 'Atlas voicingów akordów jazzowych',
    description:
      'Voicingi drop-2, drop-3, shell i bez prymy rozpisane na całym gryfie — drukowana ściąga, którą uczniowie zatrzymają na pulpicie.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/f71b389a-dbd9-4738-b77d-ce904f8c7965.jpg',
  },
]
